type JwtPayload = {
  email?: string;
  sub?: string;
};

export type AuthSnapshot = {
  isAuthenticated: boolean;
  email: string | null;
  username: string | null;
  isLoginAs: boolean;
  isMarshallReddickEmployee: boolean;
};

export type RawAuthCookies = {
  idToken?: string;
  loginAs?: string;
};

const MARSHALL_REDDICK_DOMAIN = '@marshallreddick.com';

export const LOGGED_OUT_SNAPSHOT: AuthSnapshot = {
  isAuthenticated: false,
  email: null,
  username: null,
  isLoginAs: false,
  isMarshallReddickEmployee: false,
};

/**
 * Derives the auth state from raw cookie values. Pure and environment-agnostic
 * so the SSR layout (via next/headers cookies()) and the client AuthProvider
 * (via react-cookie) compute identical snapshots from the same cookies,
 * keeping server HTML and client hydration in agreement.
 */
export function deriveAuthSnapshot(raw: RawAuthCookies): AuthSnapshot {
  let payload: JwtPayload | null = null;

  if (raw.idToken) {
    try {
      payload = JSON.parse(atob(raw.idToken.split('.')[1])) as JwtPayload;
    } catch {
      payload = null;
    }
  }

  const isAuthenticated = !!raw.idToken;
  if (!isAuthenticated) {
    return LOGGED_OUT_SNAPSHOT;
  }

  const email = payload?.email ?? null;

  return {
    isAuthenticated,
    email,
    username: payload?.sub ?? null,
    isLoginAs: !!raw.loginAs,
    isMarshallReddickEmployee:
      email?.trim().toLowerCase().endsWith(MARSHALL_REDDICK_DOMAIN) ?? false,
  };
}
